// src/hooks/useClerkReduxSync.js
import { useEffect } from 'react';
import { useUser } from '@clerk/clerk-react';
import { useDispatch, useSelector } from 'react-redux';
import { updateCurrentUser } from '../redux/actions/userActions';

export const useClerkReduxSync = () => {
  const { user: clerkUser, isLoaded, isSignedIn } = useUser();
  const dispatch = useDispatch();

  // Access the user object inside loggedUser state
  const reduxUser = useSelector((state) => state.loggedUser.user);

  useEffect(() => {
    // Exit early if session isn't active or data isn't ready
    if (!isLoaded || !isSignedIn || !clerkUser || !reduxUser?.id) {
      return;
    }

    const clerkName = `${clerkUser.firstName || ''} ${clerkUser.lastName || ''}`.trim();
    const clerkAvatar = clerkUser.imageUrl;

    // Performance: Only dispatch if values have actually changed
    const isNameDifferent = reduxUser.name !== clerkName;
    const isAvatarDifferent = reduxUser.avatar !== clerkAvatar;

    if (isNameDifferent || isAvatarDifferent) {
      dispatch(
        updateCurrentUser({
          ...reduxUser, // Spread existing data to maintain fields like access_token
          name: clerkName,
          avatar: clerkAvatar,
        })
      );
    }
  }, [clerkUser, reduxUser, isLoaded, isSignedIn, dispatch]);

  return null;
};
